module.exports = "/lucky-balls/img/bonus_yellow/header_winbet.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_winbet.png
// module id = 972
// module chunks = 0